import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
export class CustomerService {
    constructor(request) {
        this.request = request;
    }
    getCustomers() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('customers');
            return result.data;
        });
    }
    deleteCustomer(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.delete('customers/delete-customer?customerId=' + id);
            return result.data;
        });
    }
    removeLogo(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.request.delete('customers/remove-logo?customerId=' + id);
        });
    }
    getById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('customers/' + id);
            return result.data;
        });
    }
    create(customer) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.post('customers/create-customer', customer);
            if (result.errors)
                return null;
            return result.data;
        });
    }
    update(customer) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.request.patch('customers/update-customer', customer);
        });
    }
    updateLogo(file, customerId) {
        let formData = new FormData();
        formData.append('logo', file, file.name);
        formData.append('customerId', customerId);
        return this.request.post('customers/upload-logo', formData);
    }
    getCountries() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('customers/countries');
            return result.data;
        });
    }
    getCustomersName() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('customers/get-customers-name');
            return result.data;
        });
    }
}
CustomerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(i0.ɵɵinject(i1.RequestService)); }, token: CustomerService, providedIn: "root" });
